import { sortCaret } from "../../../comum/components/Icones";
import AgendamentoDashboardService from "../../../../services/AgendamentoDashboardService";
import { observable } from "mobx";
import { formatarDataCustomHTML } from './../../../../utils/formatar';


export default class ConsultaVeiculoStore {
    
    @observable veiculos;
    @observable loadingVeiculos;

    constructor() {

        this.veiculos = [];
        this.loadingVeiculos = false;

        this.service = new AgendamentoDashboardService();
    }

    listarVeiculos = () => {
        this.loadingVeiculos = true;
        this.veiculos = []
        this.service.ListarVeiculosConsulta().then(res => {
            if(res.data) {
                this.veiculos = res.data;
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loadingVeiculos = false);
    }




    colunas = [
        {
            dataField: 'VclPlacaVeiculo',
            text: 'Placa',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField: 'Cnh',
            text: 'CNH',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField: 'Nome',
            text: 'Nome',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField: 'Cntrs',
            text: 'Cntrs',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField: 'HrEntrada',
            text: 'Data Liberação',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left',
            formatter: formatarDataCustomHTML
        },
        {
            dataField: 'TipoAgend',
            text: 'Tipo',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        },
        {
            dataField: 'TempoEspera',
            text: 'Tempo liberado',
            sort: true,
            sortCaret: sortCaret,
            headerAlign: () => 'left'
        }
    ]

}



// WEBPACK FOOTER //
// ./src/modules/consultas/veiculos/stores/ConsultaVeiculosStore.js